
import Vue from 'vue';
import { Component } from 'vue-property-decorator';
import { VueGoodTable } from 'vue-good-table';
import 'vue-good-table/dist/vue-good-table.css';
import { paginationOptions, searchOptions } from '../../../../util/vue-good-table';
import { InventoryStockTaking } from '../../../backend/backendapi';
import InventoryStockTakingStore from '../../../../stores/InventoryStockTakingStore';
import { formatDateTime } from '../../../../util';
import { Like } from '../../../../util/Like';
import StockTakingEditModal from './StockTakingEditModal';
import StockTakingDeleteModal from './StockTakingDeleteModal';

@Component({
  components: {
    StockTakingDeleteModal,
    StockTakingEditModal,
    VueGoodTable,
  },
})
export default class StockTakingTab extends Vue {
  readonly store = new InventoryStockTakingStore();

  get columnsConfig(): any[] {
    return [
      {
        label: this.$t('maintenance.inventory.stockTaking.model.name').toString(),
        field: 'name',
      },
      {
        label: this.$t('maintenance.inventory.stockTaking.model.scheduledAt').toString(),
        field: 'scheduledAt',
        type: 'date',
        formatFn: (value: Date) => formatDateTime(value),
      },
      {
        label: this.$t('maintenance.inventory.stockTaking.model.completedAt').toString(),
        field: 'completedAt',
        type: 'date',
        formatFn: (value: Date | undefined) => !value ? null : formatDateTime(value),
      },
      {
        label: this.$t('maintenance.inventory.stockTaking.model.entries').toString(),
        field: 'entries',
        formatFn: (value: unknown[]) => value.length + ' ' + this.$t('maintenance.inventory.stockTaking.model.entries'),
      },
      {
        label: this.$t('general.actions').toString(),
        field: 'actions',
      },
    ];
  };

  get paginationOptions(): any {
    return paginationOptions(this.$i18n);
  }

  get searchOptions(): any {
    return searchOptions(this.$i18n);
  }

  mounted() {
    this.store.loadIfAbsent();
  }

  openAddModal(): void {
    let newStockTaking = InventoryStockTaking.fromJS({ name: '', scheduledAt: new Date(), entries: [] });
    (this.$refs.editModal as StockTakingEditModal).open(newStockTaking, true);
  }

  openDeleteModal(row: Like<InventoryStockTaking>): void {
    const original = this.store.stockTakings.find(e => e.id === row.id);
    if (!original) {
      return;
    }
    (this.$refs.deleteModal as StockTakingDeleteModal).open(original);
  }

  openEditModal(row: Like<InventoryStockTaking>): void {
    const original = this.store.stockTakings.find(e => e.id === row.id);
    if (!original) {
      return;
    }
    (this.$refs.editModal as StockTakingEditModal).open(original, false);
  }
}
